import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex align-items-center justify-content-center flex-column vh-100 text-center"
}
const _hoisted_2 = {
  key: 1,
  class: "container-fluid mb-4 text-left"
}
const _hoisted_3 = { class: "row vh-100" }
const _hoisted_4 = { class: "col-8 p-5 d-flex flex-column" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "text-center m-0" }
const _hoisted_7 = {
  key: 1,
  class: "text-center m-0"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "m-0"
}
const _hoisted_10 = {
  key: 1,
  class: "m-0 text-center"
}
const _hoisted_11 = {
  key: 2,
  class: "m-0"
}
const _hoisted_12 = {
  key: 0,
  class: "m-0"
}
const _hoisted_13 = ["href"]
const _hoisted_14 = {
  key: 1,
  class: "m-0"
}
const _hoisted_15 = ["href"]
const _hoisted_16 = {
  key: 0,
  class: "col align-items-center d-flex flex-column pt-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_spinner = _resolveComponent("loader-spinner")!
  const _component_markdown_viewer = _resolveComponent("markdown-viewer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_loader_spinner, { show: _ctx.isLoadingEvents }, null, 8, ["show"]),
    (!_ctx.eventActive && !_ctx.isLoadingEvents)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("div", { class: "card w-50" }, [
            _createElementVNode("div", { class: "card-body" }, [
              _createElementVNode("h1", null, [
                _createElementVNode("i", {
                  class: "fas fa-ticket-alt",
                  style: {"font-size":"2em"}
                })
              ]),
              _createElementVNode("h4", null, [
                _createTextVNode("Aún no hay eventos disponibles."),
                _createElementVNode("br"),
                _createTextVNode("Regresa luego")
              ])
            ])
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (_ctx.eventActive)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.event && _ctx.image)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.image,
                    alt: _ctx.event.title,
                    class: "mb-3"
                  }, null, 8, _hoisted_5))
                : _createCommentVNode("", true),
              _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.event?.title), 1),
              (_ctx.event?.date.display_start_date_time)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                    (
              _ctx.event?.location.type == 'place' && _ctx.event?.location?.address?.name
            )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.event?.location.address.name) + " • ", 1))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.date((_ctx.event?.date.start as any)._seconds * 1000)) + " ", 1),
                    (_ctx.event?.date.end)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fas fa-arrow-right mx-2" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.endDate((_ctx.event?.date.end as any)._seconds * 1000)), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.event?.details)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _cache[4] || (_cache[4] = _createElementVNode("hr", { class: "my-4" }, null, -1)),
                    _cache[5] || (_cache[5] = _createElementVNode("h5", { class: "text-uppercase" }, " Descripción del evento ", -1)),
                    _createVNode(_component_markdown_viewer, {
                      value: _ctx.showDetails,
                      id: "event-description-viewer"
                    }, null, 8, ["value"]),
                    (_ctx.event?.details.length > _ctx.maxDetails)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.expandDetails && _ctx.expandDetails(...args))),
                          class: _normalizeClass(["btn btn-link m-0 d-inline-block", { 'p-0': _ctx.detailsExpanded }])
                        }, _toDisplayString(_ctx.detailsExpanded ? "Ver menos" : "Ver más"), 3))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.event?.location.type)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _cache[11] || (_cache[11] = _createElementVNode("hr", { class: "my-4" }, null, -1)),
                    (_ctx.event?.location.type == 'on-line')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_9, [...(_cache[6] || (_cache[6] = [
                          _createElementVNode("strong", null, " El evento será en línea. El link se te hará llegar cuando inicie el evento. ", -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.event?.location.type == 'to-be-announced')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_10, [...(_cache[7] || (_cache[7] = [
                          _createElementVNode("strong", null, " El lugar del evento se estará anunciando proximamente. ", -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.event?.location.type == 'place')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.event?.title), 1),
                          _cache[8] || (_cache[8] = _createTextVNode(" se llevará a cabo en ", -1)),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.event?.location?.address?.name), 1),
                          _cache[9] || (_cache[9] = _createTextVNode(" con dirección en ", -1)),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.event?.location?.address?.address_1) + ", " + _toDisplayString(_ctx.event?.location?.address?.address_2) + ", " + _toDisplayString(_ctx.event?.location?.address?.city) + ", " + _toDisplayString(_ctx.event?.location?.address?.zip) + ", " + _toDisplayString(_ctx.event?.location?.address?.state) + ", " + _toDisplayString(_ctx.event?.location?.address?.country), 1),
                          _cache[10] || (_cache[10] = _createTextVNode(" la cita será el día ", -1)),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.date((_ctx.event?.date.start as any)._seconds * 1000)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              (
            _ctx.event?.contact && (_ctx.event?.contact.email || _ctx.event?.contact.phone)
          )
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                    _cache[14] || (_cache[14] = _createElementVNode("hr", { class: "my-4" }, null, -1)),
                    _cache[15] || (_cache[15] = _createElementVNode("p", null, " Para más información contactanos por lo siguientes medios: ", -1)),
                    (_ctx.event?.contact.email)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                          _cache[12] || (_cache[12] = _createElementVNode("strong", null, "Email: ", -1)),
                          _createElementVNode("a", {
                            href: `mailto:${_ctx.event?.contact.email}`
                          }, _toDisplayString(_ctx.event?.contact.email), 9, _hoisted_13)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.event?.contact.phone)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                          _cache[13] || (_cache[13] = _createElementVNode("strong", null, "Teléfono: ", -1)),
                          _createElementVNode("a", {
                            href: `phone:${_ctx.event?.contact.phone}`
                          }, _toDisplayString(_ctx.event?.contact.phone), 9, _hoisted_15)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "divider" }, null, -1)),
            (_ctx.event)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _cache[17] || (_cache[17] = _createElementVNode("h1", { class: "mt-5 pt-5" }, [
                    _createElementVNode("i", {
                      class: "fas fa-ticket-alt",
                      style: {"font-size":"2em"}
                    })
                  ], -1)),
                  _cache[18] || (_cache[18] = _createElementVNode("h4", null, "Compra tus tickets aquí", -1)),
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goCheckout && _ctx.goCheckout(...args))),
                    class: "btn btn-primary"
                  }, [...(_cache[16] || (_cache[16] = [
                    _createElementVNode("i", { class: "fas fa-ticket-alt me-2" }, null, -1),
                    _createTextVNode(" Comprar tickets ", -1)
                  ]))])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}